'use client';

import React from 'react';
import Link from 'next/link';

import { ContactLinks } from '@/types/types'; // Import the NavLinks type

import {
  NavigationMenu,
  NavigationMenuList,
  NavigationMenuItem,
} from '@/app/shared/ui/navigation-menu';

interface UtilityNavProps {
  contactLinks: ContactLinks;
  iconsData: Record<string, React.ReactNode>;
}

const UtilityNavigation: React.FC<UtilityNavProps> = ({
  contactLinks,
  iconsData,
}) => {
  return (
    <>
      {/* contact links */}
      <div className='flex gap-2 w-[200px] justify-end'>
        <NavigationMenu>
          <NavigationMenuList className='gap-6'>
            {contactLinks.map((link, idx) => (
              <NavigationMenuItem
                key={idx}
                className='text-foreground flex items-center'
              >
                <Link
                  href={link.url}
                  target='_blank'
                  className='text-base flex items-center gap-2 p-0 transform transition-transform duration-200 hover:scale-125'
                >
                  {' '}
                  <span> {iconsData[link.iconName]} </span>{' '}
                </Link>
              </NavigationMenuItem>
            ))}
          </NavigationMenuList>
        </NavigationMenu>
      </div>
    </>
  );
};

export default UtilityNavigation;
